import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Switch,
  FormControlLabel,
} from "@mui/material";
import AddchartIcon from "@mui/icons-material/Addchart";
import styles from "./styles.module.css";
import GenericDatePicker from "../../../components/GenericDatePicker";
import { useEffect, useState } from "react";
import { editarPreviasIcms } from "../../../services/api-planejamento-tributario.service";
import SnackBar from "../../../components/SnackBar";

const ModalEditar = ({
  open,
  onClose,
  dados,
  categorias,
  rechargeData,
  newPrevia,
}) => {
  const [dataForm, setDataForm] = useState({
    categoria: null,
    dtInicial: null,
    dtFinal: null,
  });
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });

  useEffect(() => {
    if (dados) {
      setDataForm({
        categoria: dados.categoria
          ? categorias.find((c) => c.id === dados.categoria)
          : null,
        dtInicial: new Date(dados.dtInicial),
        dtFinal: new Date(dados.dtFinal),
      });
    }
  }, [dados]);

  const handleChangeDate = (value, type) => {
    setDataForm({ ...dataForm, [type]: value });
  };

  const handleChangeSwitch = (e) => {
    const { checked } = e.target;

    setDataForm({ ...dataForm, isCPRB: checked });
  };

  const handleSubmit = async () => {
    if (!dataForm.categoria) {
      setObjSnackBar({
        type: "error",
        msg: "Por favor, preeencha ao menos uma categoria.",
      });
      return;
    }
    if (!dataForm.dtInicial || !dataForm.dtFinal) {
      setObjSnackBar({
        type: "error",
        msg: "Dt. Inicial e final são obrigatórias",
      });
      return;
    }
    try {
      // Fechar modal imediatamente
      onClose();
      await editarPreviasIcms(dados.idPreviaIcms, {
        ...dataForm,
        categoria: dataForm.categoria.id,
        status: "PREVIA-ANDAMENTO",
      });
      await rechargeData();
      setObjSnackBar({ type: "success", msg: "Prévia iniciada com sucesso!" });
    } catch (error) {
      setObjSnackBar({
        type: "error",
        msg: "Erro ao iniciar a prévia. Contate o suporte",
      });
    }
  };

  const sxControl = {
    transform: "scale(1)",
    "& .MuiSwitch-switchBase.Mui-checked": { color: "#18316E" },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#18316E",
    },
  };

  const sxFormControl = (margin) => {
    return {
      justifyContent: "flex-start",
      color: "#18316E",
      marginBottom: margin,
      marginLeft: "0rem",
      span: {
        fontSize: "0.8rem",
        fontWeight: 900,
        fontFamily: "Inter",
      },
    };
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>
          <div className={styles.title}>
            <AddchartIcon sx={{ marginRight: ".5rem" }} />{" "}
            {newPrevia ? "Iniciar Prévia" : "Editar prévia"}
          </div>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <Autocomplete
            value={dataForm.categoria}
            onChange={(_, value) => {
              setDataForm({ ...dataForm, categoria: value });
            }}
            options={categorias}
            getOptionLabel={(option) => option.label}
            fullWidth
            renderInput={(params) => (
              <TextField {...params} label="Categoria" />
            )}
          />
          <GenericDatePicker
            label="Data Inicial"
            value={dataForm.dtInicial}
            onChange={(value) => handleChangeDate(value, "dtInicial")}
          />
          <GenericDatePicker
            label="Data Final"
            value={dataForm.dtFinal}
            onChange={(value) => handleChangeDate(value, "dtFinal")}
          />
          <DialogActions className={styles.containerBtn}>
            <Button
              onClick={onClose}
              variant="contained"
              className={styles.btnCancelar}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              className={styles.btnSalvar}
              onClick={handleSubmit}
            >
              Salvar
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={setObjSnackBar} />
    </>
  );
};

export default ModalEditar;
